import { Component, OnInit, NgZone, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../authentication.service';
import { FaqsService } from '../../services/faqs.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { helpView } from './help.static.data';
import { customerServiceView } from '../subscription/subscription.static.data';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['../../app.component.css']
})

export class HelpComponent implements OnInit, AfterViewInit, OnDestroy {  
  // Static data
  customerServiceView: any;
  helpView: any;
  // Control view
  openContactForm: boolean;
  // Authentication
  isLoggedin: boolean;
  isLoggedInSubscription: Subscription;
  // User data
  name: string;
  email: string;

  constructor(public authenticationService: AuthenticationService, private router: Router, private faqsService: FaqsService, public zone: NgZone, public googleAnalyticsService: GoogleAnalyticsService) {
    this.customerServiceView = customerServiceView;
    this.helpView = helpView;
  }

  ngOnInit() {
    this.scrollToTop();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.constructHelp();
    });
  }

  ngOnDestroy(): void {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();      
    }
  }

  /*
    * Check if user has been authenticated to render either anonymous or logged in view.
    * If user is authenticated and token is not expired, check if customer has print subscriptions in order to show the complains view
  */
  constructHelp() {
    this.isLoggedInSubscription = this.authenticationService.getIsAuthenticated().subscribe((IsAuthenticated) => {
      this.zone.run(() => {
        if (IsAuthenticated && !this.authenticationService.isTokenExpired()) {
          this.isLoggedin = IsAuthenticated;
          this.authenticationService.userProfile && this.authenticationService.userProfile.firstName && this.authenticationService.userProfile.lastName ? this.name = this.authenticationService.userProfile.firstName + ' ' + this.authenticationService.userProfile.lastName : this.name = '';
          this.authenticationService.userProfile && this.authenticationService.userProfile.email ? this.email = this.authenticationService.userProfile.email : this.email = '';
        }
        IsAuthenticated && this.authenticationService.isTokenExpired() ? this.authenticationService.logoutUserExpiredSession(): '';
      });
    });
  }

  searchFAQs(value: string) { 
    this.router.navigate(['/preguntas-frecuentes'], { queryParams: { search: value } });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  scrollToTop() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if(event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/help/help.component.ts